/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import clsx from 'clsx';

import IconCheckboxChecked from '../icons/svgr/IconCheckboxChecked';
import IconCheckboxUnchecked from '../icons/svgr/IconCheckboxUnchecked';
import Input from './Input';
import InputContainer from '../forms/InputContainer';

interface Props {
  'data-testid'?: string;
  disabled?: boolean;
  field: any;
  hint?: string | JSX.Element;
  index: number;
  label?: any;
  id?: string;
  modifierClassName?: string;
  onChange?: any;
  tabIndex?: number;
}

/**
 * @deprecated
 * Please see the inputs in the ui folder of your project
 */
export default class Checkbox extends React.PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    modifierClassName: 'Checkbox--default',
  };

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (this.props.onChange) {
      this.props.onChange(this.props.index, event);
    }
  };

  render() {
    const { disabled, field, hint, id, label, modifierClassName } = this.props;

    const className = clsx('Checkbox', modifierClassName, {
      'is-disabled': disabled,
    });
    const isChecked = field.value === true;

    const newProps = {
      ...this.props,
      onChange: this.handleChange,
    };

    return (
      <>
        <InputContainer className={className}>
          <label htmlFor={id} className="Checkbox-label">
            <Input
              id={id}
              classNames="Checkbox-input"
              type="checkbox"
              {...newProps}
              checked={isChecked}
              data-testid={this.props['data-testid']}
            />
            <div className="Checkbox-indicator">
              {isChecked && <IconCheckboxChecked className="Checkbox-icon is-checked" />}
              {!isChecked && <IconCheckboxUnchecked className="Checkbox-icon" />}
              {label && <span className="Checkbox-text">{label}</span>}
            </div>
          </label>
        </InputContainer>
        {hint && <div className="Checkbox-hint">{hint}</div>}
      </>
    );
  }
}
